import Footer from '../components/Footer.jsx';
import PublicHeader from '../components/PublicHeader.jsx';
import { useTitle } from '../lib/useTitle.js';
import { useMetaTags } from '../lib/useMetaTags.js';

export default function Contact() {
  useTitle('Contact');
  useMetaTags({
    description: 'Contact TrainForge. Run a gym or want beta access? Email goes straight to the founder and gets a reply within one business day.',
    ogTitle: 'Contact TrainForge',
    ogDescription: 'Gym owners, trainers, and lifters: email the founder directly. Replies within one business day.',
    ogType: 'website',
    canonical: 'https://mytrainforge.com/contact',
  });
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <PublicHeader />

      <section style={{ flex: 1, padding: '60px 24px', maxWidth: 600, margin: '0 auto', width: '100%' }}>
        <h1 style={{ fontSize: 36, margin: '0 0 16px' }}>Get in touch</h1>
        <p style={{ color: 'var(--text-dim)', fontSize: 17, lineHeight: 1.6, margin: '0 0 32px' }}>
          Run a gym? Want beta access? Have questions? Email goes straight to me, Phil, the founder.
        </p>

        <div style={{ background: 'var(--bg-elev)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: 24, marginBottom: 16 }}>
          <h3 style={{ margin: '0 0 8px' }}>Email</h3>
          <a href="mailto:phil@mytrainforge.com" style={{ color: 'var(--accent)' }}>phil@mytrainforge.com</a>
          <p style={{ color: 'var(--text-dim)', fontSize: 14, margin: '8px 0 0' }}>
            I read every email and reply within 1 business day.
          </p>
        </div>

        <div style={{ background: 'var(--bg-elev)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: 24 }}>
          <h3 style={{ margin: '0 0 8px' }}>For gym owners</h3>
          <p style={{ color: 'var(--text-dim)', fontSize: 14, margin: '0 0 12px' }}>
            We're in beta and onboarding a small number of partner gyms. Setup takes about 15 minutes and I'll walk you through it personally.
          </p>
          <a href="mailto:phil@mytrainforge.com?subject=Beta%20access%20request" style={{ display: 'inline-block', padding: '10px 20px', background: 'var(--accent)', color: 'var(--bg)', borderRadius: 'var(--radius-md)', textDecoration: 'none', fontWeight: 600 }}>
            Request beta access
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
